import React, { useState, useEffect } from 'react';
import Loading from 'react-loading';

let showLoaderFunc = () => {};
let hideLoaderFunc = () => {};

const BusyLoader = () => {
    const [busyIcon, setBusyIcon] = useState(false);
    const [config] = useState({
        color: "red",
        width: "50px",
        height: "50px"
    });

    useEffect(() => {
        showLoaderFunc = () => setBusyIcon(true);
        hideLoaderFunc = () => setBusyIcon(false);
    }, []);

    const absStyle = {
        position: "absolute",
        top: "50%",
        marginTop: "-50px",
        zIndex: 2017
    };

    return (
        <div className="overlay" style={{
            background: "rgb(226 233 233 / 40%)",
            justifyContent: 'center',
            width: "100%",
            height: (window.innerHeight - 10),
            zIndex: 99999,
            display: busyIcon ? "flex" : "none"
        }}>
            <div style={absStyle}>
                <Loading type='spin' color={config.color} width={config.width} height={config.height} />
            </div>
        </div>
    );
};

BusyLoader.showLoader = () => {
    try {
        showLoaderFunc();
    } catch (e) {
        console.error(e.message);
    }
};

BusyLoader.hideLoader = () => {
    try {
        hideLoaderFunc();
    } catch (e) {
        console.error(e.message);
    }
};

export default BusyLoader;